import React, { useEffect } from 'react'
import { connect, type ConnectedProps, useDispatch } from 'react-redux'
import { type RootState } from '../../../../store'
import { fetchSiteInfo } from '../../redux/actionCreators'
import { type SiteInfoState } from '../../redux/siteInfoSlice'
import { siteInfoReset } from '../../redux/siteInfoSlice'
import { MemoWraperHierarchy } from '../../../common/WraperHierarchy'

interface ParentProps {
  siteId: string
  viewSitePopup: (val: string) => void
}

const ViewSite = (props: AllProps): JSX.Element => {
  const dispatch = useDispatch()
  useEffect(() => {
    props?.fetchSiteInfo(props.siteId)
  }, [props.siteId])

  useEffect(() => {
    return () => {
      dispatch(siteInfoReset())
    }
  }, [])

  const handleClose = (event: MouseEvent, reason: 'backdropClick' | 'escapeKeyDown'): void => {
    // istanbul ignore next
    if (reason !== 'backdropClick') {
      props.viewSitePopup('')
    }
  }
  return (
    <MemoWraperHierarchy
      site={props?.siteInfo?.siteInfo?.hierarchyStructure?.site}
      id={props.siteId}
      handleClose={handleClose}
      viewPopup={() => { props.viewSitePopup('') }} />
  )
}

interface DispatchToProps {
  fetchSiteInfo: (siteId: string) => void
}
const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchSiteInfo: (siteId: string) => dispatch(fetchSiteInfo(siteId))
})
interface StateToProps {
  siteInfo: SiteInfoState
}
const mapStateToProps = (state: RootState): StateToProps => ({
  siteInfo: state.siteInfoState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

type AllProps = PropsFromRedux & ParentProps
export default connector(ViewSite)
